<template>
    <div class="home__nav-item-image">
        <img :src="require(`@/public/img/${$store.state.config.skin}/banner/${img}.png`)" />
        <span v-if="label && label !== ''"> {{ getTranslatedText(label) }}</span>
    </div>
</template>
<script>
import languageMixins from "@/mixins/language-mixins";

export default {
    mixins: [languageMixins],

    props: {
        img: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
